<div *ngIf="registriaSnippet" class="registration-registria-snippet__container">
  <button class="mb-4 registration-registria-snippet__button">
    <a
      [href]="registriaSnippet.url"
      class="registration-registria-snippet__button"
      target="_blank"
    >
      {{ registriaSnippet.button_text }}
    </a>
  </button>
  <p class="mb-4">{{ registriaSnippet.header_text }}</p>

  <ul
    *ngFor="let bulletpoint of registriaSnippet.bullet_points"
    class="registration-registria-snippet__list"
  >
    <li class="ml-4">{{ bulletpoint }}</li>
  </ul>
</div>
